let savedScrollY = 0
let previousBodyOverflow = ''
let previousHtmlOverflow = ''
let previousMainOverflow = ''

export function lockPageScroll() {
	savedScrollY = window.scrollY || document.documentElement.scrollTop || 0
	previousBodyOverflow = document.body.style.overflow
	previousHtmlOverflow = document.documentElement.style.overflow
	document.body.style.overflow = 'hidden'
	document.documentElement.style.overflow = 'hidden'
	const main = document.querySelector('.main')
	if (main) {
		previousMainOverflow = main.style.overflow
		main.style.overflow = 'hidden'
	}
}

export function unlockPageScroll() {
	document.body.style.overflow = previousBodyOverflow || ''
	document.documentElement.style.overflow = previousHtmlOverflow || ''
	const main = document.querySelector('.main')
	if (main) {
		main.style.overflow = previousMainOverflow || ''
	}
	window.scrollTo(0, savedScrollY)
}
